<template>
    <div class="register-page">
        <!-- 顶部图标和欢迎语 -->
        <div class="register-header">
            <img class="img" :src="require('../assets/images/loginIcon.png')" />
            <p class="welcome-text">你好，欢迎使用~</p>
        </div>

        <!-- 登录卡片 -->
        <div class="register-card-wrapper">
            <div class="register-card">
                <!-- Tab 切换 -->
                <van-tabs v-model="activeTab" color="#5573f1" title-active-color="#5573f1"
                    title-inactive-color="#858b95" @change="onTabChange">
                    <van-tab title="验证码登录" name="code">
                        <van-form @submit="handleCodeRegister">
                            <van-field v-model="registerForm.mobile" type="tel" label="手机号" placeholder="请输入11位手机号码"
                                :rules="[{ required: true, message: '请输入手机号' }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]" />
                            <van-field v-model="registerForm.code" type="number" label="验证码" placeholder="请输入短信验证码"
                                :rules="[{ required: true, message: '请输入验证码' }]">
                                <template #button>
                                    <van-button size="small" type="info" plain hairline @click="getCode"
                                        :disabled="countdown > 0">
                                        {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
                                    </van-button>
                                </template>
                            </van-field>
                        </van-form>
                    </van-tab>

                    <van-tab title="密码登录" name="pwd">
                        <van-form @submit="handlePwdRegister">
                            <van-field v-model="registerForm.mobile" type="tel" label="手机号" placeholder="请输入11位手机号码"
                                :rules="[{ required: true, message: '请输入手机号' }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]" />
                            <van-field v-model="registerForm.password" type="password" label="密码" placeholder="请输入密码"
                                :rules="[{ required: true, message: '请输入密码' }]" />
                        </van-form>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <div v-if="activeTab == 'code'" class="tip-text">未注册的手机号登录后自动创建账号</div>
        <div v-else class="pwd-tip-wrapper">
            <van-checkbox v-model="rememberPwd">记住密码</van-checkbox>
            <span class="forget-pwd"> 忘记密码？</span>
        </div>
        <van-button type="primary" size="large" :disabled="!loginEnable" native-type="submit" round
            class="register-btn">
            登录
        </van-button>
    </div>
</template>

<script>
export default {
    name: 'RegisterView',
    data() {
        return {
            activeTab: 'code',
            registerForm: {
                mobile: '',
                code: '',
                password: ''
            },
            countdown: 0,
            rememberPwd: false,
            timer: null
        }
    },
    computed: {
        loginEnable() {
            const { mobile, code, password } = this.registerForm;
            return (this.activeTab == "code" && !!mobile && !!code) || (this.activeTab == "pwd" && !!mobile && !!password)
        },

    },
    methods: {
        onTabChange(name) {
            console.log('切换到', name)
        },
        getCode() {
            if (!this.registerForm.mobile || !/^1\d{10}$/.test(this.registerForm.mobile)) {
                this.$toast('请先输入正确的手机号')
                return
            }
            // 模拟发送验证码
            this.$toast.success('验证码已发送')
            this.countdown = 60
            this.timer = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000)
        },
        handleCodeRegister() {
            this.$toast('验证码登录')
            // 这里调用登录接口
        },
        handlePwdRegister() {
            this.$toast('密码登录')
            // 这里调用登录接口
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>

<style lang="scss" scoped>
.register-page {
    height: 100vh;
    font-size: 12px;
    background: #f1f4f9;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.register-header {
    width: 100%;
    background: linear-gradient(180deg, #d4e1f8, hsla(0, 0%, 100%, 0));
    text-align: center;
    padding-top: 30px;
    font-size: 14px;
    color: #7a89a0;

    .img {
        width: 72px;
        margin-bottom: 10px;
    }
}

.register-card-wrapper {
    width: 100%;
    padding: 20px 15px;

    .register-card {
        width: 100%;
        background: #fff;
        border-radius: 16px;
    }
}

.tip-text {
    align-self: flex-start;
    font-size: 13px;
    margin: 0 15px;
    color: #f35252;
    font-weight: 500;
}

.pwd-tip-wrapper {
    width: 100%;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin: 0 15px;
    font-weight: 500;
    color: #000018;

    .forget-pwd {
        color: #5573f1;
    }
}

.register-btn {
    margin-top: 20px;
    width: 50%;
}

::v-deep .van-button--primary {
    background-color: #5573f1;
    border-color: #5573f1;
}
</style>